import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, pure, withContext, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createFocusDecorator from 'final-form-focus';
import { withRouter } from 'react-router-dom';

import * as actions from 'actions';

import { holdMutators } from 'utils';

import Form from './Form';
import { handlers, utils } from './shared';

const propTypes = {
  initialValues: PropTypes.shape({
    application: PropTypes.shape({
      dataEntryStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      properties: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
      token: PropTypes.string,
      type: PropTypes.string,
    }),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const focusOnError = createFocusDecorator();

function ContractStatus({ initialValues, loading, onSubmit }) {
  return (
    <FinalForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      subscription={{ submitting: true, pristine: true }}
      mutators={{ ...arrayMutators, ...holdMutators }}
      decorators={[focusOnError]}
      loading={loading}
      component={Form}
    />
  );
}

ContractStatus.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    fetchApplicationFifthStep: bindActionCreators(actions.fetchApplicationFifthStep, dispatch),
    updateApplicationFifthStep: bindActionCreators(actions.updateApplicationFifthStep, dispatch),
  };
}

const enhance = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps,
  ),
  withState('loading', 'setLoading', false),
  withState('initialValues', 'setInitialValues', utils.setDefaultInitialValues()),
  withState('isFormDisabled', 'setIsFormDisabled', false),
  withHandlers({
    isFormDisabledSetter: handlers.isFormDisabledSetter,
  }),
  withHandlers({
    mergeInitialValues: handlers.mergeInitialValues,
    onSubmit: handlers.onSubmit,
  }),
  lifecycle({
    async componentDidMount() {
      const { match, fetchApplicationFifthStep, mergeInitialValues, setLoading } = this.props;
      const { token } = match.params;
      setLoading(true);
      await fetchApplicationFifthStep(token).then(mergeInitialValues);
      setLoading(false);
    },
  }),
  withContext(
    {
      isFormDisabled: PropTypes.bool,
    },
    ({ isFormDisabled }) => ({ isFormDisabled }),
  ),
  pure,
);

export default enhance(ContractStatus);
